export const en: Record<string, string> = {
  yes: "Yes",
  deleteQuestion: "Do you wish to remove this element?",
  cancelateQuestion: "¿Do you wish to cancel this order?",
  sameCar: "Use the same car?",
  Economico: "Economic",
  Automatico: "Automatic",
  AutomaticoSinSeguro: "Automatic without insurance",
  Open: "Open",
  Confirmed: "Confirmed",
  Closed: "Closed",
  Accepted: "Accepted",
  Rejected: "Rejected",
  Autorized: "Authorized",
  Pending: "Pending",
  ValidationRequired: "This field is required",
  Todos: "All"
};
